import Vue from "vue";

import Vuex from "vuex";

Vue.use(Vuex);

const state = () => ({
  dark: null,
});

const getters = {
  theme: (state) => {
    return state.dark;
  },
};

const mutations = {
  setThemeDark(state, theme) {
    state.dark = theme;
  },
};

const actions = {
  getTheme(context, theme) {
    context.commit("getTheme", theme);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
